import { lazy } from 'react';

export const CalculationOthers = lazy(() =>
    import('./CalculationOthers').then((module) => ({ default: module.CalculationOthers })),
);
